<template>
  <section>
    <p v-html="data_p1about[this.lang]" v-scroll-reveal class="first"></p>
    <p v-html="data_p2about[this.lang]" v-scroll-reveal="{ delay: 300 }" class="second"></p>
  </section>
</template>

<script>
export default {
  name: 'About',
  props: {
    lang: { type: String, default: 'EN' }
  },
  data() {
    return {
      data_p1about: {
        EN: `<span class="highlight-strong">Diwa</span> is an online sales strategy firm, dedicated to growing consumer brands. We bring creative thinking, supported by deep functional expertise in sales, marketing and ecommerce management.`,
        ES: `<span class="highlight-strong">Diwa</span> es una empresa de estrategia de ventas en línea, dedicada al crecimiento de las marcas de consumo. Aportamos un pensamiento creativo, apoyado por una profunda experiencia funcional en ventas, marketing y gestión de comercio electrónico.`
      },
      data_p2about: {
        EN: `Founded in Silicon Valley by <a class="highlight" href="https://www.linkedin.com/in/lornadiwa" target="_blank">Lorna Diwa</a>, we work with clients across the United States, Asia Pacific and Latin America.`,
        ES: `Fundada en Silicon Valley por <a class="highlight" href="https://www.linkedin.com/in/lornadiwa" target="_blank">Lorna Diwa</a>, trabajamos con clientes en los Estados Unidos, Asia Pacífico y América Latina.`
      }
    }
  }
}
</script>

<style scoped>
  section {
    max-width: 600px;
  }

  .first {
    align-self: end;
  }

  .second {
    align-self: start;
  }
</style>
